export default {
  trails: null,
  selected: null,
  showTrailLabels: true
}
